export var ReasonCategory;
(function (ReasonCategory) {
    ReasonCategory["Voluntary"] = "Voluntary";
    ReasonCategory["Involuntary"] = "Involuntary";
})(ReasonCategory || (ReasonCategory = {}));
export var VoluntaryReason;
(function (VoluntaryReason) {
    VoluntaryReason["PlansChanged"] = "PlansChanged";
})(VoluntaryReason || (VoluntaryReason = {}));
